__turbopack_context__.v({
  "big": "ProductButtons-module-scss-module__2z7r4G__big",
  "button": "ProductButtons-module-scss-module__2z7r4G__button",
  "buttonStyle": "ProductButtons-module-scss-module__2z7r4G__buttonStyle",
  "gtm-preservation-inform": "ProductButtons-module-scss-module__2z7r4G__gtm-preservation-inform",
  "isLoading": "ProductButtons-module-scss-module__2z7r4G__isLoading",
  "productButtons": "ProductButtons-module-scss-module__2z7r4G__productButtons",
  "redirectButton": "ProductButtons-module-scss-module__2z7r4G__redirectButton",
  "reservationButton": "ProductButtons-module-scss-module__2z7r4G__reservationButton",
});
